import { cn } from "@/lib/utils";
import type { PenThickness } from "./types";
import { PEN_THICKNESS_PRESETS } from "./types";

interface ThicknessBarProps {
    selectedThickness: PenThickness;
    onThicknessChange: (thickness: PenThickness) => void;
}

export function ThicknessBar({
    selectedThickness,
    onThicknessChange,
}: ThicknessBarProps) {
    return (
        <div className="flex items-center justify-evenly w-full">
            {PEN_THICKNESS_PRESETS.map((thickness) => (
                <button
                    key={thickness}
                    type="button"
                    onClick={() => onThicknessChange(thickness)}
                    className={cn(
                        "w-11 h-11 rounded-full flex items-center justify-center transition-all touch-manipulation",
                        selectedThickness === thickness
                            ? "ring-2 ring-white bg-white/20"
                            : "bg-transparent"
                    )}
                    aria-label={`Thickness ${thickness}`}
                >
                    <div
                        className="rounded-full bg-white"
                        style={{
                            width: Math.min(thickness * 2 + 8, 32),
                            height: thickness,
                        }}
                    />
                </button>
            ))}
        </div>
    );
}
